import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../modules/auth/store/reducer';
import companyReducer from '../modules/company/store/reducer';
import globalReducer from '../modules/global/store/reducer';
import meReducer from '../modules/me/store/reducer';
import userReducer from '../modules/user/store/reducer';
import articleReducer from '../modules/articles/store/reducer';
import marterReducer from '../modules/master/store/reducer';
import businessReducer from '../modules/business/store/reducer';
import containerReducer from '../modules/container/store/reducer';
import locationReducer from '../modules/location/store/reducer';
import locationReportReducer from '../modules/location-report/store/reducer';
import priceSuggestionReducer from '../modules/price-suggestion/store/reducer';
import reclassifyReducer from '../modules/reclassify/store/reducer';
import receptionReducer from '../modules/reception/store/reducer';
import warehouseReducer from '../modules/warehouse/store/reducer';
import valorizationReducer from '../modules/valorization/store/reducer';
import classifiedProductsReducer from '../modules/classified-products';
import adjustmentsReducer from '../modules/adjustments/store/reducer';

const reducers = () =>
  combineReducers({
    auth: authReducer,
    company: companyReducer,
    global: globalReducer,
    me: meReducer,
    user: userReducer,
    article: articleReducer,
    business: businessReducer,
    master: marterReducer,
    container: containerReducer,
    location: locationReducer,
    locationReport: locationReportReducer,
    priceSuggestion: priceSuggestionReducer,
    reclassify: reclassifyReducer,
    reception: receptionReducer,
    warehouse: warehouseReducer,
    valorization: valorizationReducer,
    classifiedProducts: classifiedProductsReducer,
    adjustments: adjustmentsReducer,
  });

export default reducers;
